import styled from '@emotion/styled'
import { Box } from '@mui/material'

export const RootWrap = styled(Box)(`
    margin-top: 50px;
    & .Neutral, .Mixed, .Mention {
        color: transparent !important;
    }
        
    & .driverDeepdive.subTrigger {
        padding:0;
    }
`)
